import { MarketplaceDocument } from '../useDocumentUpload';
import { uploadPresentation } from '../utils';
import DocumentsPanelRow, { ReplaceFileButton, ViewFileButton } from './DocumentsPanelRow';

type RequiredDocumentRowProps = {
  document: MarketplaceDocument;
  isReplacing: boolean;
  onReplace: () => void;
};

const RequiredDocumentRow = ({ document, isReplacing, onReplace }: RequiredDocumentRowProps) => {
  const requested = uploadPresentation('document', document.documentType);

  return (
    <DocumentsPanelRow
      thumbnailUrl={document.contentType.startsWith('image/') ? document.url : null}
      fallbackIcon={requested.icon}
      name={requested.label}
      actions={
        <>
          <ViewFileButton url={document.url} />
          <ReplaceFileButton isReplacing={isReplacing} onReplace={onReplace} />
        </>
      }
    />
  );
};

export default RequiredDocumentRow;
